import type { FC, HTMLAttributes, ReactNode } from "react";

import { classes, Text } from "@alpacahq/ui/old";

export interface PageProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  subtitle?: ReactNode;
  breadcrumbs?: ReactNode;
}

export const Page: FC<PageProps> = ({
  className,
  title,
  subtitle,
  breadcrumbs,
  children,
  ...rest
}) => (
  <div
    className={classes(
      "mx-auto w-full flex-1 space-y-8 py-8 pr-8 pl-8 xs:pl-0",
      className,
    )}
    {...rest}
  >
    {(title || subtitle || breadcrumbs) && (
      <div className="flex flex-col gap-2">
        {title && (
          <Text className="font-semibold text-2xl text-gray-900">{title}</Text>
        )}
        {subtitle && <Text className="text-gray-500 text-xl">{subtitle}</Text>}
        {breadcrumbs}
      </div>
    )}
    {children}
  </div>
);

export default Page;
